import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  headerCell: {
    fontSize: 14,
    padding: '10px !important',
    color: '#000',
    fontWeight: 700,
  },
  item: {
    lineHeight: '150%',
    boxShadow: 'none !important',
    '& > td': {
      fontSize: 14,
      padding: 10,
      color: theme.palette.grey[500],
      textTransform: 'uppercase',
    },
  },
  btnMore: {
    height: 'unset',
    marginTop: 24,
    marginBottom: 24,
    padding: '2px 20px',
    fontSize: 10,
    fontWeight: 400,
    textTransform: 'uppercase',
    lineHeight: '150%',
  },
  colorSuccess: {
    color: theme.palette.success.main,
  },
  descriptionWrapper: {
    display: 'flex',
    [theme.breakpoints.up('xs')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  InvoiceIdColumn: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 50,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      maxWidth: 70,
    },
  },
  descriptionLink: {
    color: 'inherit',
  },
}));
